import {
  GET_SEARCH_CONTEXT,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";

const initialState = {
  searchContext: [],
  page: 1,
  total: 0,
  search: "",
};

function SearchContextReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SEARCH_CONTEXT:
      return {
        ...state,
        searchContext: action.payload.data.result,
        total: action.payload.data.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    default:
      return state;
  }
}

export default SearchContextReducer;
